"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportMenuController = exports.ExportMenuControllerImpl = void 0;
const tslib_1 = require("tslib");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const i18n_1 = require("../../i18n");
const services_1 = require("../../services");
const page_state_1 = require("../../state/page.state");
const store_1 = require("../../store");
const long_running_task_manager_1 = require("../long.running.task.manager");
const ReportMaker_1 = require("../report/ReportMaker");
class ExportMenuControllerImpl {
    hasOCalcForm(collectionSummaries) {
        for (const summary of collectionSummaries) {
            const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if (formSummary != null && formSummary.metadata != null && formSummary.metadata.ocalc != null) {
                return true;
            }
        }
        return false;
    }
    hasSPIDACalcForm(collectionSummaries) {
        for (const summary of collectionSummaries) {
            const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if (formSummary != null && formSummary.metadata != null && formSummary.metadata.spidacalc != null) {
                return true;
            }
        }
        return false;
    }
    hasPoleforeman(collectionSummaries) {
        var _a;
        for (const summary of collectionSummaries) {
            const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if ((_a = formSummary === null || formSummary === void 0 ? void 0 : formSummary.metadata) === null || _a === void 0 ? void 0 : _a.poleforeman) {
                return true;
            }
        }
        return false;
    }
    hasIkePoleForeman(collectionSummaries) {
        var _a;
        for (const summary of collectionSummaries) {
            const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if ((_a = formSummary === null || formSummary === void 0 ? void 0 : formSummary.metadata) === null || _a === void 0 ? void 0 : _a.ikePoleForeman) {
                return true;
            }
        }
        return false;
    }
    hasDDS(collectionSummaries) {
        var _a;
        for (const summary of collectionSummaries) {
            const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if ((_a = formSummary === null || formSummary === void 0 ? void 0 : formSummary.metadata) === null || _a === void 0 ? void 0 : _a.dds) {
                return true;
            }
        }
        return false;
    }
    // ── Fast exports (synchronous — binary stream response) ──
    exportKML(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.executeFastExport('KML', options);
        });
    }
    exportJSON(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.executeFastExport('JSON', options);
        });
    }
    // ── Long-running exports (async — task system + download manager) ──
    exportExcel(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const revisions = this.getRevisions();
            return (0, long_running_task_manager_1.getLongRunningTaskManager)().service.startExportTask('EXCEL', revisions, 'Excel', this.getExportLabel(), {
                silent: options === null || options === void 0 ? void 0 : options.silent,
            });
        });
    }
    exportImportableExcel(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const revisions = this.getRevisions();
            return (0, long_running_task_manager_1.getLongRunningTaskManager)().service.startExportTask('IMPORTABLE_EXCEL', revisions, 'Importable Excel', this.getExportLabel(), { silent: options === null || options === void 0 ? void 0 : options.silent });
        });
    }
    exportOCalc(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const revisions = this.getRevisions((summary) => {
                const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
                return formSummary != null && formSummary.metadata != null && formSummary.metadata.ocalc != null;
            });
            return (0, long_running_task_manager_1.getLongRunningTaskManager)().service.startExportTask('OCALC', revisions, 'OCalc', this.getExportLabel(), {
                silent: options === null || options === void 0 ? void 0 : options.silent,
            });
        });
    }
    exportSPIDACalc(noPhotos, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const revisions = this.getRevisions((summary) => {
                const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
                return formSummary != null && formSummary.metadata != null && formSummary.metadata.spidacalc != null;
            });
            return (0, long_running_task_manager_1.getLongRunningTaskManager)().service.startExportTask('SPIDACALC', revisions, 'SPIDACalc', this.getExportLabel(), {
                noPhotos,
                silent: options === null || options === void 0 ? void 0 : options.silent,
            });
        });
    }
    exportPoleforeman(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const revisions = this.getRevisions((summary) => {
                const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
                return formSummary != null && formSummary.metadata != null && formSummary.metadata.poleforeman != null;
            });
            return (0, long_running_task_manager_1.getLongRunningTaskManager)().service.startExportTask('POLEFOREMAN', revisions, 'Poleforeman', this.getExportLabel());
        });
    }
    exportIkePoleForeman(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a;
            const collectionSummaries = [];
            for (const summary of page_state_1.CurrentState.Tag.collections) {
                const formSummary = yield store_1.AppStore.FormSummary.getAsync(summary.formRevision);
                if ((_a = formSummary === null || formSummary === void 0 ? void 0 : formSummary.metadata) === null || _a === void 0 ? void 0 : _a.ikePoleForeman) {
                    collectionSummaries.push(summary);
                }
            }
            const revisions = collectionSummaries.map((s) => s.revision);
            return (0, long_running_task_manager_1.getLongRunningTaskManager)().service.startExportTask('IKE_POLEFOREMAN', revisions, 'IPF', this.getExportLabel(), {
                silent: options === null || options === void 0 ? void 0 : options.silent,
            });
        });
    }
    exportDDS(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const revisions = this.getRevisions();
            return (0, long_running_task_manager_1.getLongRunningTaskManager)().service.startExportTask('DDS', revisions, 'DDS', this.getExportLabel(), {
                silent: options === null || options === void 0 ? void 0 : options.silent,
            });
        });
    }
    exportImageZip(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const revisions = this.getRevisions();
            return (0, long_running_task_manager_1.getLongRunningTaskManager)().service.startExportTask('IMAGE_ZIP', revisions, 'Images', this.getExportLabel(), {
                silent: options === null || options === void 0 ? void 0 : options.silent,
            });
        });
    }
    // ── PDF reports (client-side — unchanged) ──
    /**
     * Creates a PDF report of collections and downloads it
     * @param type The type of report to export
     */
    exportReport(type) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const revisions = page_state_1.CurrentState.Tag.collections.map((summary) => summary.revision);
            const collectionModels = yield Promise.all(revisions.map((revision) => store_1.AppStore.Collection.fetch(revision)));
            return ReportMaker_1.PDFReportMaker.makeReport(type, collectionModels);
        });
    }
    // ── Export orchestration ──
    runExport(func) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                return yield func();
            }
            catch (_) {
                notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_GENERAL });
            }
        });
    }
    // ── Private helpers ──
    /**
     * Execute a fast export (KML, JSON) via the `export.fast` action.
     * Registers the export in the download manager so it appears as a row.
     * Uses `actionRaw()` because the server streams binary data on success
     * (not JSON), which the standard `action()` / `_post()` cannot handle.
     */
    executeFastExport(type, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const revisions = this.getRevisions();
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const jobName = this.getExportLabel();
            const taskManager = (0, long_running_task_manager_1.getLongRunningTaskManager)();
            const taskId = taskManager.service.addFastExportTask(type, jobName, { silent: options === null || options === void 0 ? void 0 : options.silent });
            try {
                const response = yield services_1.Services.Department.rest.actionRaw('export.fast', {
                    type,
                    revisions,
                    timezone,
                });
                if (!response.ok) {
                    taskManager.service.failFastExportTask(taskId, undefined, 'Export failed');
                    return taskId;
                }
                const disposition = response.headers.get('Content-Disposition') || '';
                if (!disposition.includes('attachment')) {
                    // Error/warning path: server returned notifications instead of file data
                    const json = yield response.json();
                    if (json.notifications != null && json.notifications.length > 0) {
                        taskManager.service.failFastExportTask(taskId, json.notifications);
                    }
                    else {
                        taskManager.service.failFastExportTask(taskId, undefined, 'Export failed');
                    }
                    return taskId;
                }
                // Success path: file response — download as blob
                const blob = yield response.blob();
                const fileNameMatch = disposition.match(/filename="([^"]+)"/);
                const fileName = fileNameMatch ? fileNameMatch[1] : `export.${type.toLowerCase()}`;
                const url = URL.createObjectURL(blob);
                taskManager.service.completeFastExportTask(taskId, url, fileName);
            }
            catch (_err) {
                taskManager.service.failFastExportTask(taskId, undefined, 'Export failed');
            }
            return taskId;
        });
    }
    getRevisions(filter) {
        let collections = page_state_1.CurrentState.Tag.collections;
        if (filter != null) {
            collections = collections.filter(filter);
        }
        return collections.map((summary) => summary.revision);
    }
    getExportLabel() {
        var _a, _b;
        const collections = page_state_1.CurrentState.Tag.collections;
        const tagIds = page_state_1.CurrentState.Tag.tags;
        if (collections.length === 1) {
            // Single pole: "Job title - Collection title"
            const collection = collections[0];
            const tagId = collection.tags[0];
            const jobName = tagId ? (_a = store_1.AppStore.Tag.get(tagId)) === null || _a === void 0 ? void 0 : _a.name : null;
            const title = collection.title || 'Export';
            return jobName ? `${jobName} - ${title}` : title;
        }
        if (tagIds.length === 1) {
            // Multiple collections within same job: "Job title - X collections"
            const jobName = (_b = store_1.AppStore.Tag.get(tagIds[0])) === null || _b === void 0 ? void 0 : _b.name;
            return jobName ? `${jobName} - ${collections.length} collections` : `${collections.length} collections`;
        }
        // Multiple collections from multiple jobs: "X jobs - Y collections"
        return `${tagIds.length} jobs - ${collections.length} collections`;
    }
}
exports.ExportMenuControllerImpl = ExportMenuControllerImpl;
exports.ExportMenuController = new ExportMenuControllerImpl();
//# sourceMappingURL=export.menu.ctrl.js.map